const STRINGS = {
  itemCountText: (currentIndex, totalItems) => `${currentIndex} of ${totalItems} items`,
  ariaLabel: "Item Navigation",
  error: "Invalid value passed to selectedItemIndex or totalItems."
};
export default STRINGS;